import { Component } from 'react';
import MediaSizeHelper from "./MediaSizeHelper";

class ImageTransformer extends Component {
    static transform = (url, width) => {
        return `https://res.cloudinary.com/dlniynugt/image/fetch/w_${width},q_auto,f_auto/${encodeURIComponent(url)}`
    }
}

export default ImageTransformer;
